import React from 'react';
import { motion } from 'framer-motion';

const NUM_SNOWFLAKES = 50;
const getRandom = (min: number, max: number) => Math.random() * (max - min) + min;

const SnowBackground: React.FC = () => {
  // Calculate viewport height in pixels
  const viewportHeight = typeof window !== 'undefined' ? window.innerHeight : 1000;

  return (
    <div className="fixed inset-0 pointer-events-none overflow-hidden z-[1]">
      {Array.from({ length: NUM_SNOWFLAKES }).map((_, i) => {
        // Randomize initial position and animation
        const left = getRandom(0, 100); // percent
        const initialTopVH = getRandom(-10, 0); // start above viewport in vh
        const fallDistance = viewportHeight * 1.2; // fall distance: 120% of viewport height
        const duration = getRandom(10, 20); // fall duration
        const delay = getRandom(0, 5); // delay before starting
        const size = getRandom(0.3, 1.5); // size in rem
        const opacity = getRandom(0.3, 0.8);
        const horizontalDrift = getRandom(-50, 50); // horizontal movement
        
        return (
          <motion.div
            key={i}
            className="absolute text-white"
            style={{
              left: `${left}%`,
              top: `${initialTopVH}vh`,
              fontSize: `${size}rem`,
              opacity,
            }}
            animate={{
              y: [0, fallDistance],
              x: [0, horizontalDrift],
              rotate: [0, 360],
            }}
            transition={{
              duration,
              repeat: Infinity,
              delay,
              ease: "linear",
            }}
          >
            ❄
          </motion.div>
        );
      })}
    </div>
  );
};

export default SnowBackground;

